// extracted by mini-css-extract-plugin
export default {"link":"ENWEQ","skeleton-placeholder-pulse":"EPwGZ","skeletonPlaceholderPulse":"EPwGZ"};